'use strict';

const Video = {
    els: null,
    init: function () {
        Video.els = document.querySelectorAll('.c-video');
        if (Video.els && Video.els.length > 0) {
            Video.els.forEach(el => {
                Video.managePoster(el);
            });
        }
    },
    managePoster: function (el) {
        const poster = el.querySelector('.c-video__player-poster');
        if (!poster) return;

        const buttonPlay = poster.querySelector('.c-video__player-poster-play');

        //accessibilité bloquer access aux lecteurs vidéo
        const playerElements = el.querySelectorAll('iframe, video');
        playerElements.forEach(el => el.setAttribute('tabindex', '-1'));

        buttonPlay.addEventListener('click', () => {
            poster.classList.add('hidden');
            const videoType = poster.dataset.typeVideo;

            if(videoType === "youtube" && tarteaucitron && tarteaucitron?.state?.youtube) {
                let src = el.querySelector('iframe').getAttribute('src').replace('autoplay=0', '').replace('muted=0', '').replace('playsinline=0', '')
                if(src.includes('?')){
                    src+="&autoplay=1&playsinline=1"
                }
                else {
                    src+="?autoplay=1&playsinline=1"
                }
                console.log(el.querySelector('iframe').getAttribute('title'))
                let title = el.querySelector('iframe').getAttribute('title') ? el.querySelector('iframe').getAttribute('title') : "YouTube video player"
                el.querySelector('.youtube_player').innerHTML = `
                    <iframe allowfullscreen="1" allow="accelerometer; autoplay; playsinline; encrypted-media; gyroscope; picture-in-picture" title="${title}" src="${src}"></iframe>`;
                Video.updateFocus(el);
            }
            else if(videoType === "vimeo" && tarteaucitron && tarteaucitron?.state?.vimeo) {
                let src = el.querySelector('iframe').getAttribute('src').replace('autoplay=0', '').replace('muted=0', '').replace('playsinline=0', '');
                if(src.includes('?')){
                    src+="&autoplay=1&autopause=0"
                }
                else {
                    src+="?autoplay=1&autopause=0"
                }
                el.querySelector('.vimeo_player').innerHTML = `
                    <iframe frameborder="0" webkitallowfullscreen="" mozallowfullscreen=""  allow="autoplay" allowfullscreen="" src="${src}" title="Vimeo video player"></iframe>`;
                Video.updateFocus(el);
            }
            else if(videoType === "dailymotion" && tarteaucitron && tarteaucitron?.state?.dailymotion) {
                let src = el.querySelector('iframe').getAttribute('src').replace('autoplay=0', '').replace('muted=0', '').replace('playsinline=0', '');
                if(src.includes('?')){
                    src+="&autoplay=1&autopause=0"
                }
                else {
                    src+="?autoplay=1&autopause=0"
                }
                el.querySelector('.dailymotion_player').innerHTML = `
                    <iframe webkitallowfullscreen="" mozallowfullscreen=""  allow="autoplay" allowfullscreen="" src="${src}" title="Dailymotion video player"></iframe>`;
                Video.updateFocus(el);
            }
            else if(videoType === "mp4") {
                if(poster.closest('.c-video__player') && poster.closest('.c-video__player').querySelector('video'))
                    poster.closest('.c-video__player').querySelector('video').play();
                Video.updateFocus(el);
            }
        });
    },
    updateFocus:function (el) {
        // Attendre que le DOM soit mis à jour
        setTimeout(() => {
            const focusable = el.querySelector(`iframe, video`);
            if (focusable) {
                focusable.setAttribute('tabindex', '0');
                focusable.focus();
            }
        }, 100);    
    }
};

export default Video;